import { SettingsManager } from '@shared/app/scripts/services/settings-manager';

/*
 * Service eosSubmit
 */
angular
  .module('posApp')
  .factory(
    'eosSubmit',
    (
      displayMessage: any,
      endOfShift: any,
      navigateTo: any,
      persist: any,
      sessionManager: any,
      settingsManager: SettingsManager,
      translate: any,
    ) => {
      const $translate = translate,
        noAutoPrint = settingsManager.settings.noAutoPrint,
        label = noAutoPrint
          ? $translate.instant('Mail')
          : $translate.instant('PrintAndMail');

      const eosSubmit = {
        label,
        email: (email: string) => {
          const eos = endOfShift.eos;

          if (email) {
            persist.set('eosEmail', email);
          }

          displayMessage.showLoading();

          return endOfShift
            .submit(eos, email, !settingsManager.settings.noAutoPrint)
            .then(
              () => sessionManager.logout(),
              () => {
                navigateTo('pos.route#more');
              },
            );
        },
        print: () => {
          const eos = endOfShift.eos;

          displayMessage.showLoading();

          return endOfShift.submit(eos, undefined, true).then(
            () => sessionManager.logout(),
            () => {
              navigateTo('pos.route#more');
            },
          );
        },
      };

      return eosSubmit;
    },
  );
